import React, { useEffect, useContext } from "react";
import useForm from "../../../../services/UseForm";
import validate from '../../../../validations/admin/product/categoryValidate';
import '../../../../css/popUpForm.css';
import axios from "axios";
import { API } from "../../../../services/api";
import { CategoryContext } from "../category";

axios.defaults.baseURL = API;

function UpdateCategory(props) {

    const {dataList, setDataList, data, ProductTypeList} = useContext(CategoryContext);

    const handleInputStatusChange = event => {
        const { name, value } = event.target;
        handleChange(name, value)
        check(value);
    };

    const check = (params) => {
        const results = dataList.filter((data) => {
            return data.Category.toLowerCase() === params.toLowerCase()
        });
        if (results.length > 0)
            handleChange("CheckCategory", results[0].Category);
        else
            handleChange("CheckCategory", "");
    }

    const handleSelectProductType = (e) => {
        var data = ProductTypeList.filter(function (item) {
            return item.ProductType == e.target.value
        })
        if (data.length > 0) {
            handleChange("ProductType", data[0].ProductType);
            handleChange("ProductTypeID", data[0].ProductTypeID);
        } else {
            handleChange("ProductType", "");
            handleChange("ProductTypeID", "");
        }
    };

    async function update() {
        let token = localStorage.getItem("token");
        var data = {
            ProductTypeID: values.ProductTypeID,
            Category: values.Category,
        }
        await axios.put(`/updateCategory/${values.CategoryID}`, data, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {

            for (var i=0; i < dataList.length; i++) {
                if (dataList[i].CategoryID == values.CategoryID) {
                    dataList[i].ProductTypeID = values.ProductTypeID;
                    dataList[i].ProductType = values.ProductType;
                    dataList[i].Category = values.Category;
                    localStorage.setItem("categoryData", JSON.stringify(dataList));
                    break;
                }
            }  
            setDataList(dataList);
            ClearData();
            props.onClick(false);
        }).catch((err) => {
            console.log(err);
        });
    };

    const ClearData = () => {
        handleChange("ProductTypeID", "");
        handleChange("ProductType", "");
        handleChange("CategoryID", "");
        handleChange("Category", "");
    }

    const {
        values,
        errors,
        handleChange,
        handleSubmit,
    } = useForm(update, validate);

    useEffect(() => {
        data.forEach(value => {
            handleChange("ProductTypeID", value.ProductTypeID);
            handleChange("ProductType", value.ProductType);
            handleChange("CategoryID", value.CategoryID);
            handleChange("Category", value.Category);
            handleChange("CheckCategory", "");
        });
    }, [data]);

    return (
        <div style={{ display: props && props.show ? 'flex' : 'none' }} className="popUpForm">
            <div className="content">
                <div className="Header">
                    <span>ແກ້ໄຂໝວດສິນຄ້າ</span>
                </div>
                <div className="Body">
                    <form onSubmit={handleSubmit} noValidate>
                        <div className="form-row">
                            <div className="col form-group">
                                <span>ໜວດສິນຄ້າ</span>
                                <input className={`input form-control ${errors.Category && 'is-invalid'}`} type="text" name="Category" onChange={(e) => handleInputStatusChange(e)} value={values.Category || ''} required />
                                {errors.Category && (
                                    <p className="invalid-feedback">{errors.Category}</p>
                                )}
                            </div>
                            <div className="col form-group">
                                <label>ປະເພດສິນຄ້າ: </label>
                                <select name="ProductTypeID" onChange={(e) => handleSelectProductType(e)}
                                    className={`input form-control ${errors.ProductTypeID && 'is-invalid'}`}>
                                    { ProductTypeList && ProductTypeList.map((x, y) => {
                                        if (x.ProductType == values.ProductType) {
                                            return (
                                                <option key={x.ProductTypeID} value={x.ProductType} selected>
                                                    {x.ProductType}
                                                </option>
                                            )
                                        } else {
                                            return (
                                                <option key={x.ProductTypeID} value={x.ProductType}>
                                                    {x.ProductType}
                                                </option>
                                            )
                                        }
                                    })}
                                </select>
                            </div>
                        </div>
                        <div className="footer">
                            <button type="submit" className="btn btn-primary">
                                ບັນທຶກ
                            </button>
                            <button type="button" onClick={(e) => props.onClick(false)} className="btn btn-danger" data-dismiss="modal" aria-label="Close">
                                ກັບຄືນ
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateCategory;
